/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React from 'react';
import { ItemCard } from './ItemCard';
import { useTheme } from '../theme';
import { ExternalLink } from 'lucide-react';

const SponsoredAds: React.FC = () => {
  const theme = useTheme();

  const sponsoredItem = {
    id: 999,
    title: 'Premium Mountain E-Bike - Special Offer',
    price: 1450,
    distance: 'Local Business',
    image: 'https://images.unsplash.com/photo-1593764592116-bfb2a97c642a?auto=format&fit=crop&q=80&w=1200&h=600',
    rating: 5.0
  };

  return (
    <section className="py-12 border-t" style={{ borderColor: theme.colors.border }}>
      <div className="flex items-center gap-2 mb-6">
        <span className="text-xs font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-gray-200 text-gray-600">
          Sponsored
        </span>
      </div>
      
      <div className="grid grid-cols-1 gap-8">
        <div className="relative group">
          <ItemCard item={sponsoredItem} isLarge={true} />
          
          <div className="absolute bottom-8 right-8 flex flex-col items-end gap-2 md:bottom-auto md:top-24 md:right-12">
            <div className="bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-2xl border border-white/50 max-w-xs transition-transform group-hover:scale-105">
              <h4 className="font-bold text-xl mb-1" style={{ color: theme.colors.text }}>Peak Performance Cycles</h4>
              <p className="text-sm mb-4" style={{ color: theme.colors.mutedText }}>Expert local service and the best selection of electric bikes in the valley.</p>
              <button 
                className="w-full py-3 rounded-xl font-bold flex items-center justify-center gap-2 transition-all hover:opacity-90"
                style={{ backgroundColor: theme.colors.primary, color: 'white' }}
              >
                Visit Store <ExternalLink size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsoredAds;
